export type { SeededRandom } from '../utils/random';

export function formatMoney(n: number): string {
  return n.toLocaleString('zh-CN');
}

export function clamp(v: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, v));
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}
